import React from 'react';
import { Wrapper, Video, Image } from './styles.StaticMedia';
import { Note } from '../../../styles/styledComponents';

export enum MediaType {
    VIDEO = 'video',
    IMAGE = 'image',
    AUDIO = 'audio'
}

interface Props {
    src: string;
    type: MediaType;
    autoStart?: boolean;
    controls?: boolean;
    loop?: boolean;
    note?: string;
}

export const StaticMedia: React.FC<Props> = ({ src, type, autoStart, controls, loop, note }) => {
    const renderMedia = () => {
        switch (type) {
            case MediaType.AUDIO: {
                return <div>not implemented yet</div>;
            }
            case MediaType.IMAGE: {
                return <Image src={src} alt={note} />;
            }
            case MediaType.VIDEO: {
                return (
                    <Video
                        src={src}
                        playsInline
                        autoPlay={autoStart}
                        controls={controls}
                        loop={loop}
                        muted={autoStart}
                    />
                );
            }
        }
    };

    return (
        <Wrapper>
            {renderMedia()}
            {note ? <Note>{note}</Note> : undefined}
        </Wrapper>
    );
};
